// eslint-disable-next-line no-unused-vars
export default theme => ({
  root: {
    color: theme.palette.secondary.main,
  }
});
